export const homeToken = {
  Connections: "network.networkhome.connections",
  MyNetwork: "network.connections.connections.mynetwork",
  AddConnections: "network.connections.connections.addconnection",
  MyConnections: "network.connections.connections.myconnections",
  SentRequests: "network.connections.connectionlist.sentrequests",
  ReceivedRequests: "network.connections.connectionlist.receivedrequests",
  Home:  "network.connections.connections.home",
  LegacyText: "network.connections.connections.switchtolegacy",
  ClickHere: "network.connections.connections.clickhere",
  AddConnectionMessage: "network.connections.connections.connectionsadd.message",
  Search:"network.connections.connections.search",
  Connect:"network.connections.connections.connect",
  ViewProfile:"network.connections.connections.viewprofile",
  Message: "network.connections.connections.message",
  RequiredFields: "network.connections.connections.requiredfields",
  Submit: "network.connections.connections.submit",
  Cancel: "network.connections.connections.cancel",
  Sendmessage: "network.connections.connectiondetails.sendmessage",
  Yes:"network.connections.connectiondetails.yes",
  No:"network.connections.connectiondetails.no",
  MessageSentSuccess:"network.connections.connections.message.successmessage",
  Page:"network.connections.connectiondetails.page",
  Of:"network.connections.connectiondetails.of",
  Delete: "network.connections.connections.delete",
  DataNotFound:"network.connections.connections.message.datanotfound",
  Reset:"network.connections.connections.reset",
  EnterMessage:"network.connections.connections.message.placeholder",
  GenericError:"network.connections.connections.message.genericerror"

};

export const RequestsToken = {
  Accept: "network.connections.connectionrequestreceived.accept",
  Reject: "network.connections.connectionrequestreceived.reject",
  Ignore: "network.connections.connectionrequestreceived.ignore",
  NewConnectionDialogTitle: "network.connections.connectionrequestreceived.accept.dialogtitlesuccess",
  AcceptRequestDialogSuccessLeft:"network.connections.connectionrequestreceived.accept.dialogsuccessmessageleft",
  AcceptRequestDialogSuccessRight:"network.connections.connectionrequestreceived.accept.dialogsuccessmessageright",
  RejectRequestDialogTitle:"network.connections.connectionrequestreceived.rejectrequest",
  RejectRequestDialogMessage:"network.connections.connectionrequestreceived.rejectrequest.dialogmessage",
  RejectRequestSuccess:"network.connections.connectionrequestreceived.rejectrequest.successmessage",
  IgnoreRequestDialogTitle:"network.connections.connectionrequestreceived.ignorerequest",
  IgnoreRequestDialogMessage:"network.connections.connectionrequestreceived.ignorerequest.dialogmessage",
  IgnoreRequestSuccess:"network.connections.connectionrequestreceived.ignorerequest.successmessage",
  DeleteRequestDialogTitle:"network.connections.connectionsrequestsent.deleterequest",
  DeleteRequestDialogMessage:"network.connections.connectionsrequestsentdelete.areyousureyouwishtodelete",
  DeleteRequestSuccessMessage:"network.connections.connectionsrequestsentdelete.deletedsuccessfully",
};

export const ConnectionsToken = {
  SearchDirectory:"network.connections.connectionsadd.searchbnidirectory",
  AddToMyConnections:"network.connections.connectionsadd.dialogtitleconfirm",
  ConnectionRequestSentDialogTitle:"network.connections.connectionsadd.dialogtitlesuccess",
  ConnectionRequestSentDialogMessage:"network.connections.connectionsadd.dialogsuccessmessage",
  SearchMyConnections: "network.connections.connections.searchmyconnections",
  DeleteConnection:  "network.connections.connectiondetails.deleteconnection",
  GiveTestimonial: "network.connections.connectiondetails.givetestimonial",
  AskTestimonial:  "network.connections.connectiondetails.asktestimonial",
  DeleteMyConnections:"network.connections.connectiondetails.deleteconnection.dialogmessage",
  DeleteMyConnectionSuccess: "network.connections.connectiondetails.deleteconnection.successmessage",
  GiveTestimonialDialogTitle:"network.connections.connectiondetails.givetestimonial.dialogtitle",
  Testimonial:"network.connections.connectiondetails.givetestimonial.title",
  AskTestimonialDialogTitle:"network.connections.connectiondetails.asktestimonial.dialogtitle",

};

export const ErrorToken = {
  SearchLenghtError:"network.connections.connections.searchlengtherror",
  ConnectionRequestFailedMessage:"network.connections.connectionsadd.dialogfaliedmessage",
  DeleteMyConnectionFailed:"network.connections.connectiondetails.deleteconnection.failedmessage",
  FailedMessage:"network.connections.connections.message.failedmessage",
  RequestFailedMessage:"network.connections.connectionsrequestsentreminder.therewasanerrorwhileprocessingyourrequest",
};

export const NAVIGATION_PATHS = {
  Connections: "/web/connections",
  AddConnections: "/web/connections/add-connections",
  MyConnections: "/web/connections/my-connections",
  SentRequests: "/web/connections/sent-requests",
  ReceivedRequests: "/web/connections/received-requests",
};

export const MOBILE_NAV_LINKS = ["Connections", "AddConnections", "MyConnections", "SentRequests","ReceivedRequests"];

export const MYCONNECTIONS_PAGINATON_MODEL = {
  pageSize: 21,
  page: 0,
}

export const laptopMQL = "@media only screen and (max-width: 1285px)";